import type { ICashbackDetailsResources } from "@/src/cashback/CashbackDetails/CashbackDetails.Resources";

export const CashbackDetailsResourcesEn: ICashbackDetailsResources = {
    specialCashbackBadgeTitle: "Special Offer",
    specialCashbackTimeLimitText: "Expires at",
    cbAriaLabel: "Cashback {0}",
    cbSpecialAriaLabel: "Cashback {0}, previously {1}",
    shoppingMallAriaLabel: "Check all offers for {0} mall",
    flyerAriaLabel: "See all {0} promotions and flyers",
    logoAlt: "Store",
};
